import { ca } from '@cian/analytics';

import { IBrokerAnalyticsUser } from './types';

export const trackFallbackModalOpen = (user: IBrokerAnalyticsUser) => {
  ca('eventSite', {
    name: 'oldevent',
    category: 'BrokerDeal',
    action: 'Show',
    label: 'BrokerDealPopUpFail',
    page: {
      pageType: 'Listing',
      siteType: 'desktop',
      extra: {
        is_link: false,
      },
    },
    user,
    useLastProducts: true,
  });
};
